// 统一读取本地登录态 token
export function getToken() {
  return sessionStorage.getItem('site_current_token') || '';
}

export function setToken(token) {
  sessionStorage.setItem('site_current_token', token);
}

export function removeToken() {
  sessionStorage.removeItem('site_current_token');
}
